import { Entity } from '@backstage/catalog-model';

/** Annotation keys holding leadership entity refs (new format). Legacy
 *  `*-email` keys are intentionally excluded — they hold emails, not refs,
 *  and cannot be compared to RELATION_HAS_MEMBER target refs. */
export const LEADERSHIP_REF_ANNOTATIONS = [
  'team/lead',
  'team/pm',
  'team/tech-lead',
  'team/architect',
] as const;

/**
 * Extract the set of leadership entity refs from a Group entity's
 * annotations, normalized (trimmed + lower-cased) for case-insensitive
 * comparison against RELATION_HAS_MEMBER target refs.
 *
 * Mirrors the edit form's `excludeRefs` dedup (MembersPicker) so the
 * read-only view page hides leadership holders from the Members list.
 */
export function getLeadershipRefs(entity: Entity): Set<string> {
  const annotations = entity.metadata.annotations ?? {};
  const refs = new Set<string>();
  for (const key of LEADERSHIP_REF_ANNOTATIONS) {
    const value = annotations[key]?.trim();
    if (value) refs.add(value.toLowerCase());
  }
  return refs;
}
